export const NetworkRequest = {
  LoginUser: "LoginUser",
  LogoutUser: "LogoutUser",
  ResetPasswordRequest: "ResetPasswordRequest",
  ResetPasswordConfirm: "ResetPasswordConfirm",
  ResetPasswordGetEmail: "ResetPasswordGetEmail",
  ChangePassword: "ChangePassword",
  GetCurrentUser: "GetCurrentUser",
  UploadFileBeneficiarios: "UploadFileBeneficiarios",
  PostBeneficiarios: "PostBeneficiarios",
  FetchDemographicData: "FetchDemographicData",
  UsageData: "UsageData",
  FetchCities: "FetchCities",
  FetchSpecialties: "FetchSpecialties",
  FetchAttributes: "FetchAttributes",
  FetchPreExistentData: "FetchPreExistentData",
  PostAttributes: "PostAttributes",
  NavigationSteps: "NavigationSteps",
  UnlockNextStep: "UnlockNextStep",
  FetchNeedsByServiceType: "FetchNeedsByServiceType",
  FetchHasAnyCauseAndActionReport: "FetchHasAnyCauseAndActionReport",
  FetchCauseAndAction: "FetchCauseAndAction",
  PostCauseAndAction: "PostCauseAndAction",
  UpdateCauseAndAction: "UpdateCauseAndAction",
  FetchCitiesWithCauseAndActionReport: "FetchCitiesWithCauseAndActionReport",
  PostLog: "PostLog",
  FetchLogs: "FetchLogs",
  GetAllTableDimensions: "GetAllTableDimensions",
  SaveOrUpdateTableDimensions: "SaveOrUpdateTableDimensions",
  DeleteTableDimensions: "DeleteTableDimensions",
};
